import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../components/ui/alert-dialog"

type Props = {
  open: boolean
  title?: string
  description: string
  /** Override for localised callers (this layer cannot import i18n) */
  cancelText?: string
  /** Override for localised callers (this layer cannot import i18n) */
  actionText?: string
  onClose: (confirmed: boolean) => void
}

export default function ConfirmDialog({
  open,
  onClose,
  title = "Are you absolutely sure?",
  description,
  cancelText = "Cancel",
  actionText = "Continue",
}: Props) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            onClick={() => {
              onClose(false)
            }}
          >
            {cancelText}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              onClose(true)
            }}
          >
            {actionText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
